var map = {
	"./address_image.svg": 87,
	"./blogs_image.svg": 88,
	"./cloud_infrastructure.svg": 89,
	"./data_science.svg": 90,
	"./delhivery_logo.png": 91,
	"./developerActivity.svg": 92,
	"./dp1.svg": 33,
	"./education.svg": 93,
	"./experience.svg": 94,
	"./feelingProud.svg": 95,
	"./freecopy_logo.png": 96,
	"./fullstack.svg": 97,
	"./gcp_logo.svg": 98,
	"./googleAssistant.svg": 99,
	"./google_logo.svg": 100,
	"./intel_logo.svg": 101,
	"./jsFramework.svg": 102,
	"./legato_logo.svg": 103,
	"./logo.png": 30,
	"./manOnTable.svg": 104,
	"./microsoft_logo.png": 105,
	"./muffito_logo.svg": 106,
	"./programmer.svg": 107,
	"./projects_image.svg": 108,
	"./talksCardBack.svg": 109,
	"./talksCardBackAlt.svg": 110,
	"./tiktok_logo.svg": 111,
	"./ui_ux_design.svg": 112
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 29;